function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.841164,
  width: 60,
  height: 60,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1554_1197)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.0911 49.2461V47.4961H29.0911V42.4961H12.8411C11.7578 42.4961 10.862 42.1419 10.1536 41.4336C9.4453 40.7253 9.09113 39.8294 9.09113 38.7461V14.4961C9.09113 13.4128 9.4453 12.5169 10.1536 11.8086C10.862 11.1003 11.7578 10.7461 12.8411 10.7461H48.8411C49.9245 10.7461 50.8203 11.1003 51.5286 11.8086C52.237 12.5169 52.5911 13.4128 52.5911 14.4961V38.7461C52.5911 39.8294 52.237 40.7253 51.5286 41.4336C50.8203 42.1419 49.9245 42.4961 48.8411 42.4961H32.5911V47.4961H37.5911V49.2461H24.0911ZM12.8411 40.7461H48.8411C49.3411 40.7461 49.7995 40.5378 50.2161 40.1211C50.6328 39.7044 50.8411 39.2461 50.8411 38.7461V14.4961C50.8411 13.9961 50.6328 13.5378 50.2161 13.1211C49.7995 12.7044 49.3411 12.4961 48.8411 12.4961H12.8411C12.3411 12.4961 11.8828 12.7044 11.4661 13.1211C11.0495 13.5378 10.8411 13.9961 10.8411 14.4961V38.7461C10.8411 39.2461 11.0495 39.7044 11.4661 40.1211C11.8828 40.5378 12.3411 40.7461 12.8411 40.7461Z",
  fill: "white"
}));

function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1554_1197",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.e5a23c32.svg";
export { ForwardRef as ReactComponent };